require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-124-project-health-report.json") })
        }
      }, "path---article-124-project-health-report");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-124-project-health-report!./.cache/json/article-124-project-health-report.json
// module id = 480
// module chunks = 231608221292675